// ===================== ส่ง OTP =====================

export function initOtp() {
  // เปิดปุ่มตามความถูกต้องของเบอร์
  document.addEventListener('input', onPhoneInputValidate, { passive: true });

  // Delegation: ปุ่มส่ง OTP
  document.addEventListener('click', onSendOtpClick);
}

/* ---------- Utilities ---------- */
function normalizeThaiPhone(raw) {
  // ตัดทุกอย่างที่ไม่ใช่ตัวเลข
  let digits = (raw || '').replace(/\D+/g, '');
  // แปลง +66XXXXXXXXX -> 0XXXXXXXXX
  if (digits.startsWith('66') && digits.length === 11) {
    digits = '0' + digits.slice(2);
  }
  return digits;
}

function isValidThaiMobile(raw) {
  const digits = normalizeThaiPhone(raw);
  return /^0\d{9}$/.test(digits);
}

function setBtnLoading(btn, loading) {
  btn.disabled = !!loading;
  btn.setAttribute('aria-busy', loading ? 'true' : 'false');
}

/* ---------- Handlers ---------- */
function onPhoneInputValidate(e) {
  const form = e.target.closest('form');
  if (!form) return;

  const phoneInput = form.querySelector('[data-phone]');
  const btn = form.querySelector('.btn-sendotp');
  if (!phoneInput || !btn) return;

  btn.disabled = !isValidThaiMobile(phoneInput.value);
}

async function onSendOtpClick(e) {
  if (!e.target.matches('.btn-sendotp')) return;

  e.preventDefault();
  e.stopPropagation();

  const btn = e.target;
  const form = btn.closest('form');
  const phoneInput = form?.querySelector('[data-phone]');
  const type = btn.dataset.type || '';

  if (!phoneInput || !isValidThaiMobile(phoneInput.value)) {
    Swal.fire({ title: 'กรุณากรอกเบอร์มือถือให้ถูกต้อง', icon: 'warning' });
    return;
  }

  // กันเคสมี interval เก่า
  clearExistingCountdown(btn);

  // สถานะโหลด
  const originalText = btn.textContent;
  setBtnLoading(btn, true);
  btn.textContent = 'กำลังส่ง...';

  // ใช้ endpoint จาก data-otp-endpoint บนปุ่ม (ถ้ามี) หรือคำนวณจาก path ปัจจุบัน
  const normalized = normalizeThaiPhone(phoneInput.value);
  const fieldMap = {
    'login':          'phone-login',
    'reset-password': 'phone-reset-password',
    'register':       'phone-register',
  };
  const fieldName = fieldMap[type] || 'phone-register';
  const formData = new FormData();
  formData.append(fieldName, normalized);
  formData.append('type', type);

  // data-otp-endpoint="admin/function.php" บนปุ่ม หรือ fallback คำนวณจาก path
  const customEndpoint = btn.dataset.otpEndpoint;
  const base = document.querySelector('base')?.href
    || (window.location.origin + window.location.pathname.replace(/\/[^/]*$/, '/'));
  const endpoint = customEndpoint
    ? new URL(customEndpoint, window.location.origin + '/').href + '?sendotp'
    : new URL('function.php?sendotp', base).href;

  // timeout 15s
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort(), 15000);

  try {
    const res = await fetch(endpoint, {
      method: 'POST',
      body: formData,
      signal: controller.signal,
    });
    clearTimeout(t);

    // รองรับ res ไม่ ok
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error('Invalid JSON');
    }

    // โครงตอบกลับที่คาดหวัง: { error: boolean, msg: string, retry_in?: number }
    if (data.error) {
      await Swal.fire({
        title: data.msg || 'ไม่สามารถส่งรหัสได้',
        icon: 'warning',
        showCloseButton: true,
        showConfirmButton: false,
      });
      setBtnLoading(btn, false);
      btn.textContent = originalText || 'ขอรหัส';
      return;
    }

    await Swal.fire({
      title: data.msg || 'ส่งรหัสสำเร็จ',
      icon: 'success',
      showCloseButton: true,
      showConfirmButton: false,
    });

    // โฟกัสช่อง OTP
    const otpInput = form.querySelector('input[name="otpcode"]');
    if (otpInput) otpInput.focus();

    // เริ่ม countdown
    const seconds = Number.isFinite(+data.retry_in) ? Math.max(0, +data.retry_in) : 60;
    startCountdown(btn, seconds);

  } catch (err) {
    console.error(err);
    const msg = err.name === 'AbortError' ? 'เครือข่ายช้าหรือหมดเวลา' : 'เกิดข้อผิดพลาด';
    Swal.fire({ title: msg, icon: 'error' });
    setBtnLoading(btn, false);
    btn.textContent = originalText || 'ขอรหัส';
  }
}

/* ---------- Countdown logic ---------- */
function startCountdown(btn, seconds) {
  const expiresAt = Date.now() + seconds * 1000;
  btn.dataset.expiresAt = String(expiresAt);

  // ปิดปุ่มช่วง countdown
  setBtnLoading(btn, true);
  tick(); // อัพเดททันทีหนึ่งครั้ง

  const id = setInterval(tick, 250); // อัพเดทถี่ขึ้นให้เนียน

  btn.dataset.intervalId = String(id);

  function tick() {
    const remainMs = expiresAt - Date.now();
    const remain = Math.max(0, Math.ceil(remainMs / 1000));
    btn.textContent = `ส่งอีกครั้ง ${remain}s`;

    if (remain <= 0) {
      clearExistingCountdown(btn);
      setBtnLoading(btn, false);
      btn.textContent = 'ขอรหัส';
    }
  }
}

function clearExistingCountdown(btn) {
  const oldId = btn.dataset.intervalId;
  if (oldId) {
    clearInterval(Number(oldId));
    delete btn.dataset.intervalId;
  }
  delete btn.dataset.expiresAt;
}
